import { useCallback } from 'react'

import styled from '@emotion/styled'
import { useFormContext } from 'react-hook-form'

import { TextArea } from '@cash-design-system/react'
import { FormBlockerElementMultilineTextInputElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

const MultilineTextArea = styled(TextArea)`
  /* stylelint-disable-next-line property-no-unknown -- experimental property */
  field-sizing: content;
  border: unset;
  background-color: unset;
  min-height: unset;

  :focus {
    border: unset;
  }

  :invalid {
    border: ${({ theme }) => `2px solid ${theme.colors.error}`};
  }
`

export const MultilineTextInputElement = ({
  formSectionIndex,
  hint_text,
  prefill_text,
  max_character_count,
  disallow_newlines,
  collapse_whitespace,
  is_required,
}: FormBlockerElementMultilineTextInputElement & { formSectionIndex: number }) => {
  const { register } = useFormContext()

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      if (collapse_whitespace) {
        e.target.value = e.target.value.replace(/\s+/g, ' ')
      } else if (disallow_newlines) {
        e.target.value = e.target.value.replace(/[\n\r]/g, ' ')
      }
    },
    [collapse_whitespace, disallow_newlines]
  )

  return (
    <MultilineTextArea
      placeholder={hint_text}
      defaultValue={prefill_text}
      maxLength={max_character_count}
      {...register(`${formSectionIndex}.multiline_text_input_result`, {
        required: is_required,
        onChange,
      })}
    />
  )
}
